export const sizes = {
  s: 540,
  m: 720,
  l: 1024,
  xl: 1200,
}
